import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export const LoadingIcon = LoadingOutlined;

export const Loading = ({ padding, size = 'large' }) => (
  <div style={{ paddingBlock: padding, textAlign: 'center' }}>
    <Spin size={size} indicator={<LoadingIcon />} />
  </div>
);

export default Loading;
